import {ERROR, UNIT} from '@di-shared/const';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import {emitEventLog} from '@di-shared/features/analytics';
import {ROUTE_PATHS} from '@di-shared/routes';
import {useNavigate} from 'react-router';
import {UbiSectionKrProps} from '@di-shared/features/home/kr/benefit/UbiSection.kr';

function UbiSectionErrorKr({vin}: UbiSectionKrProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();
  return (
    <section className="section section_ubi">
      <div className="section_container">
        <div className="section_container_header">
          <div className="container_header_title">
            <h3 className="label_medium_b">{t('T20019')}</h3>
            <strong className="title_xxsmall">{t('T10137')}</strong>
          </div>
          <div className="container_header_imgbox">
            <ImageSelector
              alt="ubi-discount-logo"
              kiaLightSrc={() => import('@di-shared/assets/img/home/ubi_discount_light.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/home/ubi_discount.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/ubi_discount_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/ubi_discount.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/ubi_discount_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/ubi_discount.png')}
            />
          </div>
        </div>
        <ul className="ubi_discount_list">
          <li className="ubi_discount_item">
            <div className="ubi_discount_icon">
              <span className="ic ic_fuel_efficiency_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10138')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">{ERROR.DASH}</em>
              {UNIT.PERCENT}
            </span>
          </li>

          <li className="ubi_discount_item">
            <div className="ubi_discount_icon">
              <span className="ic ic_share_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10144')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')}
              <em className="text_emphasis">{ERROR.DASH}</em>
              {UNIT.PERCENT}
            </span>
          </li>
          <li className="ubi_discount_item">
            <div className="ubi_discount_icon">
              <span className="ic ic_location_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10145')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">{ERROR.DASH}</em>
              {UNIT.PERCENT}
            </span>
          </li>
          <li className="ubi_discount_item">
            <div className="ubi_discount_icon">
              <span className="ic ic_svm_all_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10146')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">{ERROR.DASH}</em>
              {UNIT.PERCENT}
            </span>
          </li>
        </ul>

        <button
          className="btn btn_large btn_filled btn_full"
          type="button"
          onClick={() => {
            emitEventLog({
              event: 'insurance_deals',
              form_step: 'view more',
              click_text: t('T10147'),
              click_location: 'body',
            });
            navigate(ROUTE_PATHS.UBI.getFullPath(vin));
          }}
        >
          {t('T10147')}
        </button>
      </div>

      <p className="notice_desc">{t('T10148')}</p>
    </section>
  );
}

export default UbiSectionErrorKr;
